import React from "react";
import "../LandingPage/LandingPage.css";
import Footer from "../../Components/Footer/FooterSmall";
import Header2 from "../../Components/Header2/Header2";
import ScheduleForm from "../../Content/Forms/ScheduleForm/ScheduleForm";
import RequestInfoFrom from "../../Content/Forms/RequestInfoForm2/RequestInfoForm";
import "./RequestInfo.css";
import SecHeader from "../../Components/SecHeader/SecHeader";

const RequestInfo: React.FC = () => {
  return (
    <div className="generalPage">
      <Header2 />
      <div className="pageContainer">
        <div className="request-info-title-container">
          <div className="sectionContainer">
            <SecHeader title="Request Info" iSize={3} />
          </div>
          <div className="request-info-container">
            <div className="request-info-card">
              <RequestInfoFrom />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RequestInfo;
